<template>
	<v-container style="max-width:100% !important" grid-list-md>
		<v-layout text-xs-center wrap>
			<v-flex mb-4 xs12>
				<h1 class="display-1 font-weight-Medium mb-3">
					Welcome to Secondary Sales Extraction
				</h1>
			</v-flex>
			<v-layout text-xs-center row wrap>
				<v-flex
					v-if="userType == 30 ? true : false"
					mb-4
					xs12
					sm6
					md4
					fill-height
				>
					<v-card flat max-width class="top-card-styling">
						<v-card-title primary-title>
							Enter File name with extension below to download the file.
						</v-card-title>
						<v-card-text>
							<v-text-field
								color="yellow darken-3"
								v-model="fileName"
								label="Enter File Name"
								hint="90dc5074-e2b7-4973-adc9-899906c5e677.xls"
								placeholder="90dc5074-e2b7-4973-adc9-899906c5e677.xls"
							>
								<template v-slot:append-outer>
									<v-btn
										icon
										color="green darken-1"
										flat
										@click="downloadFileFromServer"
									>
										<v-icon>get_app</v-icon>
									</v-btn>
								</template>
							</v-text-field>
						</v-card-text>
						<v-card-text>
							<v-text-field
								color="yellow darken-3"
								v-model="fileNameArray"
								label="Enter File Name Array here"
								:hint="hintAndPlaceHolderText0"
								:placeholder="hintAndPlaceHolderText0"
							>
								<template v-slot:append-outer>
									<v-btn
										icon
										color="green darken-1"
										flat
										@click="bulkDownloadFileFromServer"
									>
										<v-icon>get_app</v-icon>
									</v-btn>
								</template>
							</v-text-field>
						</v-card-text>
						<!-- <span>E.G. [&quot;90dc5074-e2b7-4973-adc9-899906c5e677.xls&quot;]</span> -->
					</v-card>
				</v-flex>
				<!-- <v-flex v-if="false" mb-4 xs12 sm6 md4 fill-height>
					<v-card flat max-width class="top-card-styling">
						<v-card-title primary-title>Export Monthly Data</v-card-title>
						<v-card-text>
							<v-select
								v-model="selectedMonth"
								:items="months"
								label="Selected Month"
							></v-select>
							<v-select
								v-model="selectedYear"
								:items="years"
								label="Selected Year"
							></v-select>
						</v-card-text>
						<v-card-actions style="justify-content:flex-end;">
							<div class="btn-wrap">
								<v-btn flat color="green darken-1" @click="exportExtractedData"
									>Download Data Log</v-btn
								>
								<v-btn
									flat
									color="green darken-1"
									@click="exportFilteredExtractedData"
									class="text--wrap"
									>Data Log With Selected Dates</v-btn
								>
							</div>
						</v-card-actions>
					</v-card>
				</v-flex> -->

				<v-flex
					v-if="userType == 30 ? false : true"
					mb-4
					xs12
					sm12
					md4
					fill-height
				>
					<v-card flat max-width class="top-card-styling">
						<v-card-title primary-title>Push Logs to FTP</v-card-title>
						<v-card-text
							>This button will push the data and mail log to respective FTP
							sites</v-card-text
						>
						<v-card-actions style="margin-left:175px; margin-top:30px">
							<v-btn outline color="green accent-4" @click="pushMLDL"
								>Push ML/DL</v-btn
							>
						</v-card-actions>
					</v-card>
				</v-flex>

				<v-flex
					v-if="userType == 30 ? false : true"
					mb-4
					xs12
					sm12
					md4
					fill-height
				>
					<v-card flat max-width class="top-card-styling">
						<v-card-title primary-title>Export Mail Log</v-card-title>
						<v-card-text>
							Mail log for the dates selected in the top Navigation.
						</v-card-text>
						<v-card-actions style="margin-right:170px;">
							<v-spacer></v-spacer>
							<v-btn flat color="green darken-1" @click="downloadMailMeta"
								>Download Mail Log</v-btn
							>
						</v-card-actions>
					</v-card>
				</v-flex>
				<!-- <v-flex
					v-if="userType == 30 ? true : false"
					mb-4
					xs12
					sm12
					md4
					fill-height
				>
					<v-card flat max-width class="top-card-styling">
						<v-card-title primary-title style="padding-bottom:0px"
							>Input filename array to FORCE REJECT files.</v-card-title
						>
						<v-card-title
							primary-title
							style="padding-top:0px; padding-bottom:0px;"
							>Please use with caution.</v-card-title
						>
						<v-card-text>
							<v-text-field
								color="yellow darken-3"
								v-model="filesToBeRejected"
								label="Enter UUID Array here"
								:hint="hintAndPlaceHolderText1"
								:placeholder="hintAndPlaceHolderText1"
							>
								<template v-slot:append-outer>
									<v-btn
										icon
										color="red darken-3"
										flat
										@click="forceRejectFiles"
									>
										<v-icon>delete</v-icon>
									</v-btn>
								</template>
							</v-text-field>
						</v-card-text>
					</v-card>
				</v-flex> -->
				<v-flex
					v-if="userType == 30 ? false : true"
					mb-4
					xs12
					sm12
					md4
					fill-height
				>
					<v-card flat max-width class="top-card-styling">
						<v-card-title primary-title>Upload Weights</v-card-title>
						<v-card-text>Select model weights .pkl file to Upload</v-card-text>
						<v-card-actions style="margin-right:55px; margin-top:30px">
							<v-spacer></v-spacer>
							<input
								accept=".pkl"
								type="file"
								ref="file"
								@change="
									ev => {
										loadFile('WEIGHTS', ev);
									}
								"
							/>
						</v-card-actions>
					</v-card>
				</v-flex>
				<v-flex
					v-if="userType == 30 ? false : true"
					mb-4
					xs12
					sm12
					md4
					fill-height
				>
					<v-card flat max-width class="top-card-styling">
						<v-card-title primary-title>Upload Brand Master</v-card-title>
						<v-card-text>Select most brand master file to Upload</v-card-text>
						<v-card-actions style="margin-right:55px; margin-top:30px">
							<v-spacer></v-spacer>
							<input
								accept=".csv"
								type="file"
								ref="file"
								@change="
									ev => {
										loadFile('BRAND_MASTER', ev);
									}
								"
							/>
						</v-card-actions>
					</v-card>
				</v-flex>
				<!-- v-if="userType == 30 ? true : false" -->
				<v-flex
					mb-4
					xs12
					sm12
					md4
					fill-height
				>
					<v-card flat max-width class="top-card-styling">
						<v-card-title primary-title
							>Backend Reject with Additional Remarks</v-card-title
						>
						<v-card-text
							>If no reason is selected file will just get Backend Reject
							remark</v-card-text
						>
						<v-card-title primary-title style="padding-bottom:0px"
							>Input filename array to FORCE REJECT files.</v-card-title
						>
						<v-card-title
							primary-title
							style="padding-top:0px; padding-bottom:0px;"
							>Please use with caution.</v-card-title
						>
						<v-card-text>
							<v-autocomplete
								v-model="selectedReasons"
								:items="rejectReasons"
								:allow-overflow="false"
								multiple
								flat
								placeholder="Reject with Reason"
							></v-autocomplete>
							<v-text-field
								color="yellow darken-3"
								v-model="filesToBeRejected"
								label="Enter UUID Array here"
								:hint="hintAndPlaceHolderText1"
								:placeholder="hintAndPlaceHolderText1"
							>
								<template v-slot:append-outer>
									<v-btn
										icon
										color="red darken-3"
										flat
										@click="forceRejectFiles"
									>
										<v-icon>delete</v-icon>
									</v-btn>
								</template>
							</v-text-field>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
			<v-flex mb-4 xs12>
				<v-card flat max-width class="card-styling">
					<v-card-title primary-title>Stockist wise summary</v-card-title>
					<v-card-text>
						<div class="small">
							<pie-chart
								:options="pieChartOptions"
								:chart-data="stockistPieData"
							></pie-chart>
						</div>
					</v-card-text>
					<v-card-title primary-title
						>Total: - {{ stockistPieData.total }}</v-card-title
					>
				</v-card>
			</v-flex>
			<v-flex mb-4 xs12>
				<v-card flat max-width class="card-styling">
					<v-card-title primary-title>Monthly Trend Line</v-card-title>
					<v-card-text>
						<div>
							<line-chart
								:options="lineChartOptions"
								v-if="Object.keys(lineChartData).length > 0"
								:lineChartData="lineChartData"
							></line-chart>
						</div>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs12>
				<h1 class="headline font-weight-Medium mb-3 text-xs-left">
					File extension wise summary
				</h1>
			</v-flex>
			<v-flex
				v-for="(extn, index) of extensions"
				:key="extn"
				mb-4
				xs12
				:sm6="index != extensions.length - 1"
			>
				<v-card flat max-width class="card-styling">
					<v-card-title primary-title>{{ extn }}</v-card-title>
					<v-card-text>
						<div class="small">
							<pie-chart
								:options="pieChartOptions"
								:chart-data="pieChartData[extn]"
							></pie-chart>
						</div>
					</v-card-text>
					<v-card-title primary-title
						>Total: - {{ pieChartData[extn].total }}</v-card-title
					>
				</v-card>
			</v-flex>
			<v-flex mb-4 xs12>
				<v-card flat max-width class="card-styling">
					<v-card-title primary-title>Creator Wise Meta Count</v-card-title>
					<v-card-text>
						<div class="bar-chart-container">
							<bar-chart
								:options="barChartOptions"
								:chart-data="barChartData"
							></bar-chart>
						</div>
					</v-card-text>
					<v-card-title primary-title
						>Total: - {{ barChartData.total }}</v-card-title
					>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import moment from 'moment-timezone';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import PieChart from './PieChart.js';
import LineChart from './LineChart.js';
import BarChart from './BarChart.js';
export default {
	components: {
		PieChart,
		LineChart,
		BarChart,
	},
	data: () => ({
		hintAndPlaceHolderText0: '["90dc5074-e2b7-4973-adc9-899906c5e677.xls"]',
		hintAndPlaceHolderText1: '["90dc5074-e2b7-4973-adc9-899906c5e677"]',
		fileName: '',
		fileNameArray: '',
		selectedMonth: '',
		selectedYear: '',
		months: [
			'JANUARY',
			'FEBRUARY',
			'MARCH',
			'APRIL',
			'MAY',
			'JUNE',
			'JULY',
			'AUGUST',
			'SEPTEMBER',
			'OCTOBER',
			'NOVEMBER',
			'DECEMBER',
		],
		years: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
		stockistPieData: {},
		pieChartData: {},
		pieChartOptions: {
			responsive: true,
			maintainAspectRatio: false,
			animation: {
				easing: 'linear',
				duration: 3000,
			},
		},
		barChartData: {},
		barChartOptions: {
			responsive: true,
			maintainAspectRatio: false,
			animation: {
				easing: 'easeOutCubic',
				duration: 5000,
			},
		},
		lineChartData: {},
		lineChartOptions: { responsive: true, maintainAspectRatio: false },
		filesToBeRejected: '',
		selectedReasons: [],
		rejectReasons: [...require('./rejects.json')],
	}),
	created() {
		for (let extn of this.extensions) {
			this.stockistPieData = this.pieChartData[extn] = {
				labels: ['Extracted', 'Rejected', 'Others'],
				datasets: [
					{
						label: 'One',
						backgroundColor: '#087979',
						data: [],
					},
				],
				total: 0,
			};
		}
		this.fillData();
	},
	methods: {
		...mapActions([
			'downloadFile',
			'modelInputUpload',
			'downloadExtractedData',
			'downloadMailLog',
			'getOverallSummary',
			'getTrendLine',
			'getStockistWiseSummary',
			'getCreatorWiseMetaCount',
			'downloadFileWiseExtractionPercentage',
			'pushMailLogAndDataLog',
		]),
		...mapActions('fileExtraction', ['forceRejectFilesFromBackend']),
		...mapMutations(['openLoaderDialog', 'closeLoaderDialog', 'openSnackbar']),
		jsonValidate(json) {
			try {
				var j = JSON.parse(json);
				return true;
			} catch (err) {
				return false;
			}
		},
		downloadFileFromServer() {
			this.openLoaderDialog();
			if (this.fileName) {
				this.downloadFile(this.fileName).then(_ => {
					this.closeLoaderDialog();
				});
			}
		},
		async bulkDownloadFileFromServer() {
			if (this.jsonValidate(this.fileNameArray)) {
				let fileArray = JSON.parse(this.fileNameArray);
				this.openLoaderDialog();
				for (let file of fileArray) {
					await this.downloadFile(file);
				}
				this.closeLoaderDialog();
			}
		},
		exportExtractedData() {
			this.openLoaderDialog();
			this.downloadExtractedData({
				month: this.selectedMonth,
				year: this.selectedYear,
			}).then(_ => {
				this.closeLoaderDialog();
			});
		},
		exportFileWiseExtractionDetails() {
			this.openLoaderDialog();
			this.downloadFileWiseExtractionPercentage({
				month: this.selectedMonth,
				year: this.selectedYear,
			}).then(_ => {
				this.closeLoaderDialog();
			});
		},
		exportFilteredExtractedData() {
			this.openLoaderDialog();
			this.downloadExtractedData({
				month: this.selectedMonth,
				year: this.selectedYear,
				dates: this.getSelectedDates,
			}).then(_ => {
				this.closeLoaderDialog();
			});
		},
		downloadMailMeta() {
			this.openLoaderDialog();
			this.downloadMailLog(this.getSelectedDates).then(_ => {
				this.closeLoaderDialog();
			});
		},
		fillData() {
			// on first load App sets the default range after this runs,
			// the selectedDates watcher loads these charts then
			if (this.selectedDates.length) {
				this.fillDateWiseData();
			}

			this.getTrendLine(/* this.getSelectedDates */).then(data => {
				if (data.ok) {
					this.lineChartData = data.trendLine;
					this.$set(this, 'lineChartData', data.trendLine);
				}
			});

			this.getCreatorWiseMetaCount().then(data => {
				if (data.ok) {
					this.barChartData = data.analytics;
					this.$set(this, 'barChartData', data.analytics);
				}
			});
		},
		// charts that depend on the selected date range
		fillDateWiseData() {
			this.getOverallSummary(this.getSelectedDates).then(data => {
				if (data.ok) {
					this.pieChartData = data.summary;
				}
			});

			this.getStockistWiseSummary(this.getSelectedDates).then(data => {
				if (data.ok) {
					this.stockistPieData = data.analytics;
				}
			});
		},
		getRandomInt(max) {
			return Math.floor(Math.random() * Math.floor(max));
		},
		pushMLDL() {
			this.pushMailLogAndDataLog()
				.then(data => {
					if (data) {
						this.openSnackbar({
							text: 'Request made successfully',
						});
					} else {
						this.openSnackbar({
							text: 'Failed to make request',
						});
					}
				})
				.catch(e => {
					console.log('pushMLDL err', e);
				});
		},
		forceRejectFiles() {
			if (window.confirm('Are you sure you want to FORCE REJECT all FILES')) {
				if (this.jsonValidate(this.filesToBeRejected)) {
					let filesToDelete = JSON.parse(this.filesToBeRejected);
					// console.log(filesToDelete);

					this.openLoaderDialog();
					let additionalRemark = '';
					if (this.selectedReasons.length) {
						additionalRemark = this.selectedReasons.join(', ');
					}
					this.forceRejectFilesFromBackend({
						uuids: filesToDelete,
						additionalRemark,
					})
						.then(data => {
							this.closeLoaderDialog();
							if (data) {
								this.selectedReasons = [];
								this.openSnackbar({
									text: 'Sucessfully rejected files!',
								});
							} else {
								this.openSnackbar({
									text: 'Failed to reject files',
								});
							}
						})
						.catch(e => {
							this.closeLoaderDialog();
							this.openSnackbar({
								text: 'Failed to reject files',
							});
							this.refreshStockistList();
						});
				} else {
					this.openSnackbar({
						text: 'Invalid Array, Please try again',
					});
				}
			}
		},
		loadFile: function(tag, ev) {
			const file = ev.target.files[0];
			const reader = new FileReader();

			reader.readAsArrayBuffer(file);

			reader.onload = e => {
				this.openLoaderDialog();
				this.modelInputUpload(this.createFormData(tag, file)).then(data => {
					this.closeLoaderDialog();
					if (data.ok) {
						this.openSnackbar({
							text: data.message,
						});
					} else {
						this.openSnackbar({
							text: data.message,
						});
					}
					ev.target.value = '';
				});
			};
		},
		createFormData(tag, file) {
			let formData = new FormData();
			formData.append(tag, file);
			return formData;
		},
	},
	computed: {
		...mapGetters([
			'getSelectedDates',
			'selectedDates',
			'extensions',
			'startDay',
			'userType',
		]),
	},
	watch: {
		selectedDates() {
			this.fillDateWiseData();
		},
	},
	mounted() {
		if (
			Number(
				moment()
					.tz('Asia/Kolkata')
					.format('DD')
			) >= this.startDay
		) {
			this.selectedMonth = moment()
				.startOf('month')
				.add(this.startDay - 1, 'day')
				.tz('Asia/Kolkata')
				.format('MMMM')
				.toUpperCase();
		} else {
			this.selectedMonth = moment()
				.startOf('month')
				.subtract(1, 'month')
				.add(this.startDay - 1, 'day')
				.tz('Asia/Kolkata')
				.format('MMMM')
				.toUpperCase();
		}
		this.selectedYear = moment().format('YYYY');
	},
};
</script>

<style scoped>
.small {
	max-width: 300px;
	margin: 0px auto;
}

.top-card-styling {
	min-height: 338px;
	border: 1px solid #dcdcdc;
	border-radius: 8px;
}

.card-styling {
	min-height: 320px;
	box-shadow: 0px 6px 18px 0px hsla(0, 0%, 0%, 0.2);
	border-radius: 8px;
}

.container {
	max-width: 800px;
	margin: 0 auto;
}

.bar-chart-container {
	max-width: 600px;
	margin: 0px auto;
}

.btn-wrap {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: flex-end;
}
</style>
